(function(root){
  'use strict';
  function viewURL(href,view){
    var url=new URL(href);
    url.searchParams.set('view',view==='list'?'list':'grid');
    url.hash='';
    return url.href;
  }
  function filterURL(href,entries){
    var url=new URL(href);
    Array.from(url.searchParams.keys()).forEach(function(key){if(key.indexOf('filter.')===0||key==='page'||key==='sort_by'||key==='view')url.searchParams.delete(key);});
    Array.from(entries).forEach(function(pair){if((pair[0].indexOf('filter.')===0||pair[0]==='sort_by'||pair[0]==='view')&&pair[1]!=='')url.searchParams.append(pair[0],pair[1]);});
    url.hash='';
    return url.href;
  }
  function removeURL(current,target){
    var from=new URL(current),url=new URL(target,from);
    if(url.origin!==from.origin)return from.href;
    from.searchParams.forEach(function(value,key){if(key.indexOf('filter.')!==0&&key!=='page'&&!url.searchParams.has(key))url.searchParams.append(key,value);});
    url.searchParams.delete('page');
    return url.href;
  }
  if(typeof module==='object'&&module.exports){module.exports={viewURL:viewURL,filterURL:filterURL,removeURL:removeURL};return;}
  if(!root.document||root.__acCollectionControls)return;
  root.__acCollectionControls=true;
  var doc=root.document;
  function refresh(){
    doc.querySelectorAll('[data-ac-collection] [data-ac-view]').forEach(function(link){link.href=viewURL(root.location.href,link.dataset.acView);});
    doc.querySelectorAll('[data-ac-collection] [data-ac-remove]').forEach(function(link){link.href=removeURL(root.location.href,link.getAttribute('href'));});
  }
  doc.addEventListener('submit',function(event){
    var form=event.target;
    if(!form.matches('[data-ac-filters]'))return;
    if(!form.reportValidity())return;
    var range=Array.from(form.querySelectorAll('input[type=number]'));
    if(range.length===2&&range[0].value!==''&&range[1].value!==''&&Number(range[0].value)>Number(range[1].value)){
      event.preventDefault();range[1].min=range[0].value;range[1].reportValidity();range[1].min='0';return;
    }
    event.preventDefault();root.location.assign(filterURL(root.location.href,new FormData(form).entries()));
  });
  doc.addEventListener('change',function(event){if(event.target.matches('[data-ac-sort]')&&event.target.form)event.target.form.requestSubmit();});
  doc.addEventListener('keydown',function(event){if(event.key!=='Escape')return;var facet=event.target.closest('[data-ac-facet][open]');if(facet){facet.open=false;facet.querySelector('summary').focus();}});
  doc.addEventListener('shopify:section:load',refresh);
  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
})(typeof window==='undefined'?{}:window);
